export default "__VITE_ASSET__CqBlt92o__"